import React from "react";

const StarFill = ({ rating, className=""}) => {
  const clampedRating = Math.max(0, Math.min(rating, 5));
  const fillPercent = (clampedRating / 5) * 100;

  return (
    <svg
      className={`w-5 h-5 mb-1 ${className}`}
      viewBox="0 0 24 24"
      fill="none"
      stroke="#10b981"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <defs>
        <linearGradient id="starFillGradient" x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset={`${fillPercent}%`} stopColor="#10b981" />
          <stop offset={`${fillPercent}%`} stopColor="transparent" />
        </linearGradient>
      </defs>
      <path
        d="M12 17.25L18.18 21l-1.64-7.03L22 9.24
           l-7.19-.61L12 2 9.19 8.63 2 9.24
           l5.46 4.73L5.82 21z"
        fill="url(#starFillGradient)"
      />
    </svg>
  );
};

export default StarFill;